import { filter } from 'rxjs/operators';

import type { EffectParams } from '@swf/core/store';
import { select } from '@swf/core/store';
import { canUseDOM } from '@swf/core/utils';

export const pageChange = (actions: EffectParams['actions']) =>
  canUseDOM ? actions.pipe(filter(({ type }) => type === 'page/response')) : null;

export const login = (actions: EffectParams['actions']) =>
  canUseDOM
    ? actions.pipe(
        filter(
          ({ type, state }) =>
            type === 'session/response' && select.session.isClientAuthenticated(state)
        )
      )
    : null;

export const logout = (actions: EffectParams['actions']) =>
  canUseDOM ? actions.pipe(filter(({ type }) => type === 'auth/logout')) : null;
